import axios from "axios";
import { API_BASE_URL } from "../constants/api";
import { ACCESS_TOKEN } from "../constants/auth";

const UserService = {};
UserService.getUserByToken = async () => {
  // let data = new FormData();
  // const token = localStorage.getItem(ACCESS_TOKEN);
  // data.append("token", token);

  return axios({
    method: "post",
    url: API_BASE_URL + "/api/user/get/token",
    // data: data,
    headers: {
      // "Content-Type": "multipart/form-data",
      Authorization: `Bearer ${localStorage.getItem(ACCESS_TOKEN)}`,
    },
  });
};

UserService.updateProfile = async function (
  lastName,
  firstName,
  middleName,
  contactNumber,
  birthday,
  gender,
  country,
  city,
  school,
  schoolClass,
  expectedGraduationDate,
  languageSkills,
  foreignLanguageSkills
) {
  let data = new FormData();
  data.append("lastName", lastName);
  data.append("firstName", firstName);
  if (middleName) {
    data.append("middleName", middleName);
  }
  if (contactNumber) {
    data.append("contactNumber", contactNumber);
  }

  if (birthday) {
    const day = String(new Date(birthday).getDate()).padStart(2, "0");
    const month = String(new Date(birthday).getMonth() + 1).padStart(2, "0"); // Months are zero-based
    const year = new Date(birthday).getFullYear();
    data.append("birthday", `${day}.${month}.${year}`);
  }

  data.append("gender", gender);
  data.append("country", country);
  data.append("city", city);
  data.append("school", school);
  if (schoolClass) {
    data.append("schoolClass", schoolClass);
  }
  if (expectedGraduationDate) {
    data.append(
      "expectedGraduationDate",
      new Date(expectedGraduationDate).toLocaleDateString()
    );
  }
  if (languageSkills) {
    data.append("languageSkills", languageSkills);
  }
  if (foreignLanguageSkills) {
    data.append("foreignLanguageSkills", foreignLanguageSkills);
  }

  return axios({
    method: "post",
    url: API_BASE_URL + "/api/user/profile/update",
    data: data,
    headers: {
      "Content-Type": "multipart/form-data",
      Authorization: `Bearer ${localStorage.getItem(ACCESS_TOKEN)}`,
    },
  });
};

// UserService.register = async (
//     username,
//     password,
// ) => {
//     let data = new FormData();
//     data.append("username", username);
//     data.append("password", password);
//
//     return axios({
//         method: "post",
//         url: API_BASE_URL + "/api/user/register",
//         data: data,
//         headers: {
//             "Content-Type": "multipart/form-data",
//         }
//     });
// }
export default UserService;
